import { patch, IPatchStorage } from '../../private';
import load from './dbupdate';
import { IConfigAPI } from '../../../interface/config';
import { IProgressPromise, IProgressPromiseGenerator } from '../../../interface/promise';
import { IAuthenticationManager } from '../../../controller/interface/auth';
import { siteDataResponseToEntityMap } from './util';
import { ISiteData, ISiteDataAPI } from '../../../api/interface/siteData';
import { IWorkspaceDB } from '../../../db/interface/db';

function update(
    configAPI: Array<Partial<IConfigAPI>>,
    siteAPI: ISiteDataAPI,
    promiser: IProgressPromiseGenerator,
    name: string,
    db: IWorkspaceDB,
    auth: IAuthenticationManager,
): IProgressPromise<void> {
    return promiser.promise(async function (resolve, reject, progress) {
        try {
            await db.open();

            progress(0.1);

            const token = await auth.renew();

            progress(0.2);

            const existingPatch: IPatchStorage = await patch.storage.load(name).catch(error => ({
                name: name,
                hash: '',
                data: {},
            }));

            progress(0.3);

            const urls = configAPI.map(config => config.url).filter(url => url) as Array<string>;

            let siteData: ISiteData | null = null;

            for (const urlAPI of urls) {
                const siteFetcher = siteAPI.getSiteData(urlAPI, token, existingPatch.hash);

                siteFetcher.onProgress(function (data: number) {
                    progress(0.3 + data * 0.3);
                });

                progress(0.6);

                siteData = await siteFetcher.catch(error => {
                    console.error(
                        `Failed to fetch api-url: ${urlAPI}, error:${JSON.stringify(error)}`,
                    );
                    return null;
                });

                if (siteData) {
                    break;
                }
            }

            if (!siteData) {
                throw new Error(`Unable to find any site data`);
            } else if (siteData.patch.length > 0) {
                /* only bother if there is something in the patch */
                const newPatch: IPatchStorage = { ...existingPatch };
                newPatch.data = await patch.apply(siteData.patch, existingPatch.data);
                newPatch.hash = siteData.currentHash;

                await patch.storage.save(newPatch);

                const applicator = siteDataResponseToEntityMap(newPatch.data);

                await load(promiser, db, db.preInsertCleanup(applicator));
            }

            progress(0.8);

            db.close();

            resolve();
        } catch (error) {
            reject(error);
        }
    });
}

export default update;
